// import React from "react";
// import { Paper, Typography } from "@mui/material";
// import { InfoOutlined } from "@mui/icons-material";
// import {
//   warningColor,
//   warningSoft,
//   textPrimary,
//   softShadow,
// } from "../../../constants/consts";
// import { MESSAGES } from "../../../constants/consts";

// export default function ContractWarning() {
//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2,
//         borderRadius: 3,
//         display: "flex",
//         alignItems: "flex-start",
//         gap: 1.5,
//         backgroundColor: warningSoft,
//         border: `1px solid ${warningColor}3D`,
//         boxShadow: softShadow,
//       }}
//     >
//       <InfoOutlined sx={{ color: warningColor, mt: 0.25 }} />
//       <Typography
//         variant="body2"
//         color={textPrimary}
//         fontWeight={600}
//         sx={{ lineHeight: 1.5 }}
//       >
//         {MESSAGES.CONTRACT_WARNING}
//       </Typography>
//     </Paper>
//   );
// }
import React from "react";
import { Paper, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { keyframes } from "@mui/system"; // ← EKLE
import {
  warningColor,
  warningSoft,
  textPrimary,
  softShadow,
} from "../../../constants/consts";
import { MESSAGES } from "../../../constants/consts";

// Nazik nabız — dikkat çeker ama göz yormaz
const pulse = keyframes`
  0%, 100% { transform: scale(1);    opacity: 1; }
  50%      { transform: scale(1.15); opacity: 0.85; }
`;

export default function ContractWarning() {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 3,
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        backgroundColor: warningSoft,
        border: `1px solid ${warningColor}3D`,
        boxShadow: softShadow,
        transition: "transform 0.25s ease, box-shadow 0.25s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 10px 24px rgba(0,0,0,0.10)",
        },
      }}
    >
      <InfoOutlined
        sx={{
          color: warningColor,
          mt: 0.25,
          animation: `${pulse} 2.4s ease-in-out 1.2s infinite`,
          transformOrigin: "center",
        }}
      />
      <Typography
        variant="body2"
        color={textPrimary}
        fontWeight={600}
        sx={{ lineHeight: 1.5 }}
      >
        {MESSAGES.CONTRACT_WARNING}
      </Typography>
    </Paper>
  );
}
